import React, { useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ListItemText from "@mui/material/ListItemText";
import styles from "./Drawer.module.scss";
import Logo from "../../assets/images/new-logo.svg";
import CollapseIcon from "../../assets/images/collapse.svg";
import { useLocation } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import { ReactComponent as HomeIcon } from "../../assets/images/overview.svg";
import { ReactComponent as ArticleIcon } from "../../assets/images/business.svg";
import { ReactComponent as FolderSpecialIcon } from "../../assets/images/transaction.svg";
import { ReactComponent as RefreshSquare } from "../../assets/images/rollingreserve.svg";
import { ReactComponent as Bank } from "../../assets/images/compliance.svg";
import { ReactComponent as ShieldSlash } from "../../assets/images/fraudmgt.svg";
import { ReactComponent as Moneys } from "../../assets/images/payment.svg";
import { ReactComponent as EmptyWallet } from "../../assets/images/wealth.svg";
import { ReactComponent as UsersPermission } from "../../assets/images/usersPerm.svg";
import { ReactComponent as SettingsThree } from "../../assets/images/utility.svg";
import { ReactComponent as Activity } from "../../assets/images/marketing.svg";
import { ReactComponent as BusinessApproval } from "../../assets/images/business-approval.svg";
import { ReactComponent as FeesApproval } from "../../assets/images/fees-approval.svg";
import { ReactComponent as LimitsApproval } from "../../assets/images/limits-approval.svg";
import { ReactComponent as ConfigApproval } from "../../assets/images/config-approval.svg";
import { ReactComponent as SettlementSchedule } from "../../assets/images/settlement-schedule.svg";
import { ReactComponent as Refunds } from "../../assets/images/refunds.svg";
import { ReactComponent as Chargebacks } from "../../assets/images/chargebacks.svg";
import { ReactComponent as FlaggedTransactions } from "../../assets/images/flagged-transactions.svg";
import { ReactComponent as HotlistedCards } from "../../assets/images/hotlisted-cards.svg";
import { ReactComponent as PaymentLinks } from "../../assets/images/payment-links.svg";
import { ReactComponent as Invoices } from "../../assets/images/invoices.svg";
import { ReactComponent as WealthSummary } from "../../assets/images/wealth-summary.svg";
import { ReactComponent as ProviderBalances } from "../../assets/images/provider-balances.svg";
import { ReactComponent as Users } from "../../assets/images/users.svg";
import { ReactComponent as Roles } from "../../assets/images/roles.svg";
import { ReactComponent as Modules } from "../../assets/images/modules.svg";
import { ReactComponent as BusinessCategories } from "../../assets/images/business-categories.svg";
import { ReactComponent as Countries } from "../../assets/images/countries.svg";
import { ReactComponent as PendingIcon } from "../../assets/images/due.svg";
import { ReactComponent as ListIcon } from "../../assets/images/settlement.svg";
import { ReactComponent as AssuredWorkloadIcon } from "../../assets/images/customer.svg";
import { ReactComponent as BriefCaseIcon } from "../../assets/images/briefcase.svg";
import { ReactComponent as DocumentIcon } from "../../assets/images/documenttext.svg";
import { ReactComponent as AccountIcon } from "../../assets/images/account_balance.svg";
import { ReactComponent as SettlementIcon } from "../../assets/images/videotime.svg";
import { ReactComponent as LimitIcon } from "../../assets/images/clipboardclose.svg";
import { ReactComponent as PaymentIcon } from "../../assets/images/cardpos.svg";
import { ReactComponent as UserIcon } from "../../assets/images/usersquare.svg";
import { ReactComponent as RecentSettleIcon } from "../../assets/images/walletmoney.svg";
import { ReactComponent as CustomerIcon } from "../../assets/images/profile2user.svg";
import { ReactComponent as RollingIcon } from "../../assets/images/arrowrotateright.svg";
import { ReactComponent as PropertyIcon } from "../../assets/images/payment-property.svg";
import { ReactComponent as TransactionsIcon } from "../../assets/images/transactions-icon.svg";
import { ReactComponent as DownloadIcon } from "../../assets/images/download.svg";
import ComponentListItem from "../drawerListItem/ComponentListItem";
import { Tooltip } from "@mui/material";
import { HasAccess } from "@permify/react-role";
import { useSelector } from "react-redux";
import { sub } from "date-fns";

const sideBarMenus = [
  {
    id: "DAO",
    title: "Overview",
    route: "/",
    icon: <HomeIcon />,
    permission: "HOME_TREND_TRANSACTION",
  },
  {
    id: "DB",
    title: "Businesses",
    route: "/businesses",
    icon: <ArticleIcon />,
    permission: "BUSINESS_LIST",
  },
  {
    id: "DTM",
    title: "Transactions",
    route: "/transactionmgt",
    icon: <FolderSpecialIcon />,
    permission: "TRANSACTION_LIST",
    subMenus: [
      {
        id: "DTM",
        title: "Transactions",
        route: "/transactionmgt",
        icon: <FolderSpecialIcon />,
        permission: "VIEW_TRANSACTION",
        subMenus: [],
      },
      {
        id: "DCR",
        title: "Refunds",
        route: "/refunds",
        icon: <Refunds />,
        permission: "",
        subMenus: [],
      },
      {
        id: "DCA",
        title: "Chargebacks",
        route: "/transactionmgt/chargebackmgt",
        icon: <Chargebacks />,
        permission: "CHARGEBACK_LIST",
        subMenus: [],
      },
      {
        id: "DCD",
        title: "Chargeback Summary",
        route: "/transactionmgt/chargebackmgt/summary",
        icon: <Chargebacks />,
        permission: "CHARGEBACK_LIST",
        subMenus: [],
      },
    ],
  },
  {
    id: "DS",
    title: "Settlements",
    route: "/settlements",
    icon: <ListIcon />,
    permission: "SETTLEMENT_LIST",
    subMenus: [
      {
        id: "DS",
        title: "All Settlements",
        route: "/settlements",
        icon: <ListIcon />,
        permission: "SETTLEMENT_LIST",
        subMenus: [],
      },
      {
        id: "DSP",
        title: "Due Settlements",
        route: "/settlements/due",
        icon: <PendingIcon />,
        permission: "",
        subMenus: [],
      },
      {
        id: "DSP",
        title: "Download files",
        route: "/settlements/processor",
        icon: <DownloadIcon />,
        permission: "",
        subMenus: [],
      },
    ],
  },
  {
    id: "RRM",
    title: "Rolling reserve",
    route: "/rollingreserve",
    icon: <RefreshSquare />,
    permission: "REVERSE_ROLLINGRESERVE",
    subMenus: [],
  },
  {
    id: "CFM",
    title: "Compliance",
    route: "/compliance",
    permission: "APPROVE_BUSINESS",
    icon: <Bank />,
    subMenus: [
      {
        id: "CFM",
        title: "Business Approval",
        route: "/compliance",
        icon: <BusinessApproval />,
        permission: "APPROVE_BUSINESS",
        subMenus: [],
      },
      {
        id: "DPA",
        title: "Limits Approval",
        route: "/compliance/limit",
        icon: <LimitsApproval />,
        permission: "VIEW_BUSINESS_LIMIT",
        subMenus: [],
      },
      {
        id: "CFE",
        title: "Fees Approval",
        route: "/compliance/fees",
        icon: <FeesApproval />,
        permission: "APPROVE_BUSINESS_FEE",
        subMenus: [],
      },
      {
        id: "ASD",
        title: "Configuration Approval",
        route: "/compliance/config",
        icon: <ConfigApproval />,
        permission: "APPROVE_BUSINESS_CONFIG",
        subMenus: [],
      },
      {
        id: "POI",
        title: "Settlement Schedule",
        route: "/compliance/schedule",
        icon: <SettlementSchedule />,
        permission: "VIEW_BUSINESS_SETTLEMENT_SCHEDULE",
        subMenus: [],
      },
    ],
  },
  {
    id: "DFMS",
    title: "Fraud Management",
    route: "/fraudmgt",
    icon: <ShieldSlash />,
    permission: "FRAUD_FLAGGED_LIST",
    subMenus: [
      {
        id: "DFMS",
        title: "Flagged Transactions",
        route: "/fraudmgt",
        icon: <FlaggedTransactions />,
        permission: "FRAUD_FLAGGED_LIST",
        subMenus: [],
      },

      {
        id: "DFRA",
        title: "Hotlisted Cards",
        route: "/hotlist",
        icon: <HotlistedCards />,
        permission: "HOTLISTED_CARD_LIST",
        subMenus: [],
      },
    ],
  },
  {
    id: "PRM",
    title: "Payment",
    route: "/payout",
    icon: <Moneys />,
    permission: "PAYMENTS",
    subMenus: [
      {
        id: "PRM",
        title: "Payouts",
        route: "/payout",
        icon: <Moneys />,
        permission: "PAYOUT_LIST",
        subMenus: [],
      },
      {
        id: "DBC",
        title: "Payment Links",
        route: "/paymentlinks",
        icon: <PaymentLinks />,
        permission: "",
        subMenus: [],
      },
      {
        id: "MIOS",
        title: "Invoices",
        route: "/merchantinvoice",
        icon: <Invoices />,
        permission: "",
        subMenus: [],
      },
    ],
  },
  {
    id: "DBCM",
    title: "Customer",
    route: "/customermgt",
    icon: <AssuredWorkloadIcon />,
    permission: "CUSTOMER_LIST",
    subMenus: []
  },
  {
    id: "DFMW",
    title: "Wealth",
    route: "/summary",
    icon: <EmptyWallet />,
    permission: "WEALTH_MANAGER",
    subMenus: [
      {
        id: "DFMW",
        title: "Summary",
        route: "/summary",
        icon: <WealthSummary />,
        permission: "WEALTH_MANAGER",
        subMenus: [],
      },

      {
        id: "WEBA",
        title: "Provider Balances",
        route: "/wealth/balance",
        icon: <ProviderBalances />,
        permission: "PROVIDER_BALANCE",
        subMenus: [],
      },
    ],
  },
  {
    id: "DU",
    title: "Users & Permissions",
    route: "/usersandpermissions",
    icon: <UsersPermission />,
    permission: "USERS_VIEW",
    subMenus: [
      {
        id: "DU",
        title: "Users",
        route: "/usersandpermissions",
        icon: <Users />,
        permission: "USERS_VIEW",
        subMenus: [],
      },

      {
        id: "DUR",
        title: "Roles",
        route: "/usersandpermissions/roles",
        icon: <Roles />,
        permission: "ROLE_MODULE",
        subMenus: [],
      },

      {
        id: "DUM",
        title: "Modules",
        route: "/usersandpermissions/modules",
        icon: <Modules />,
        permission: "",
        subMenus: [],
      },
    ],
  },
  {
    id: "CCTM",
    title: "Utility",
    route: "/utility/countrylist",
    icon: <SettingsThree />,
    permission: "COUNTRY_LIST",
    subMenus: [
      {
        id: "CCTM",
        title: "Countries",
        route: "/utility/countrylist",
        icon: <BusinessCategories />,
        permission: "COUNTRY_LIST",
        subMenus: [],
      },

      {
        id: "CCCL",
        title: "Categories",
        route: "/utility/categorylist",
        icon: <Countries />,
        permission: "",
        subMenus: [],
      },
      {
        id: "CWCL",
        title: "Routes",
        route: "/utility/routes",
        icon: <Countries />,
        permission: "ROUTES_LIST",
        subMenus: [],
      },
      {
        id: "CWCL",
        title: "Providers",
        route: "/utility/providers",
        icon: <SettingsThree />,
        permission: "ROUTES_LIST",
        subMenus: [],
      },
      {
        id: "CWCL",
        title: "Custom Reports",
        route: "/utility/custom-reports",
        icon: <DownloadIcon />,
        permission: "ROUTES_LIST",
        subMenus: [],
      },
    ],
  },
  {
    id: "MCA",
    title: "Marketing",
    route: "/marketingmgt",
    icon: <Activity />,
    permission: "MARKETING_LIST",
    subMenus: [],
  },
  {
    id: "MCNULL",
    title: "",
    route: "/index",
  },
];

const drawerWidth = 269;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  background: "#1A1E21",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  background: "#1A1E21",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer() {
  interface sidebarMenusProps {
    route: string;
    title: string;
    id: string;
    icon?: React.ReactElement | any;
    permission?: string;
    subMenus?: any[];
  }

  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  // const location = useLocation();
  const { pathname } = useLocation();
  const [sidebarMenus, setSidebarMenus] = useState(sideBarMenus);
  // const handleDrawerOpen = () => {
  // 	setOpen(!open);
  // };

  const handleDrawerClose = () => {
    setOpen(!open);
  };

  const MuiListItem = withStyles({
    root: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      padding: open ? "1px 0 1px 0px" : "1px 0 1px 0px",
    },
  })(ListItem);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    if (width <= 850) {
      setOpen(false);
    } else if (width > 850) {
      setOpen(true);
    }
  }, [width]);

  let businessId = localStorage.getItem("businessId");

  const businessRoutes = [
    {
      id: "DTM",
      title: "Business Information",
      route: `/businesses/info/${businessId}`,
      icon: <BriefCaseIcon />,
      permission: "",
    },
    {
      id: "DCR",
      title: "Limit",
      route: `/businesses/limit/${businessId}`,
      icon: <LimitIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Fees",
      route: `/businesses/fees/${businessId}`,
      icon: <AccountIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Settlements",
      route: `/businesses/settlements/${businessId}`,
      icon: <SettlementIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Documents",
      route: `/businesses/documents/${businessId}`,
      icon: <DocumentIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Payment Methods",
      route: `/businesses/payment-method/${businessId}`,
      icon: <PaymentIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Users",
      route: `/businesses/users/${businessId}`,
      icon: <UserIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Recent Settlements",
      route: `/businesses/recent-settlements/${businessId}`,
      icon: <RecentSettleIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Customers",
      route: `/businesses/customers/${businessId}`,
      icon: <CustomerIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Recent transactions",
      route: `/businesses/recent-transactions/${businessId}`,
      icon: <TransactionsIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Recent rolling reserves",
      route: `/businesses/rolling-reserves/${businessId}`,
      icon: <RollingIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Payment Property",
      route: `/businesses/payment-property/${businessId}`,
      icon: <PropertyIcon />,
      permission: "",
    },
    {
      id: "DCA",
      title: "Payment Route",
      route: `/businesses/payment-route/${businessId}`,
      icon: <RecentSettleIcon />,
      permission: "",
    },
  ];

  const auth = useSelector((state) => state?.mePayReducer?.me?.user);


  useEffect(() => {
    let route = window.location.pathname.split("/")[1];
    if (route === "signIn") return;
    if (!route.includes("businesses")) {
      localStorage.removeItem("businessId");
    }
    if (route.includes("businesses") && businessId) {
      setSidebarMenus(businessRoutes);
    } else {
      var current = sideBarMenus.filter((item) =>
        item.route.includes(route)
      )[0];
      current && current.subMenus && setSidebarMenus(current.subMenus);
    }

    // : setSidebarMenus(sideBarMenus);
  }, [window.location.pathname]);

  if (
    pathname.toLowerCase() === "/signup" ||
    pathname.toLowerCase() === "/signin" ||
    pathname.toLowerCase() === "/individual_signup" ||
    pathname.toLowerCase() === "/email" ||
    pathname.toLowerCase() === "/forgotpass" ||
    pathname.toLowerCase() === "/customer" ||
    pathname.toLowerCase() === "/merchant" ||
    pathname.toLowerCase() === "/forgotpassword" ||
    pathname.toLowerCase() === "/newpassword" ||
    pathname.toLowerCase() === "/reset-password" ||
    pathname.toLowerCase() === "/email_verification"
  ) {
    return <div></div>;
  }
  if (
    pathname.toLowerCase() === "/business/signup" ||
    pathname.toLowerCase() === "/ngo/signup"
  ) {
    return <div></div>;
  }

  if (
    window.location.pathname.split("/")[1] === "monitor-servers" ||
    window.location.pathname.split("/")[1] === "monitor-transactions"
  ) {
    return <div />;
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}></AppBar>
      <Drawer variant="permanent" open={open}>
        <div className={open ? styles.logo : styles.logoResize}>
          <img src={Logo} alt="" className={styles.logoimg} />
          {open && (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {/* <div className={styles.dot}></div> */}
              {auth && auth?.userRole.userRoleName === "PARTNER" ? <p>{auth?.partner.name ?? ""}</p> :
                <p className={styles.logoAdmin}>Admin</p>
              }
            </div>
          )}
        </div>

        <div className={styles.wrapperList}>
          <div className={styles.drawerMenu}>
            <>
              {sidebarMenus.length !== sideBarMenus.length ? (
                <button
                  className={styles.backButton}
                  onClick={() => {
                    setSidebarMenus(sideBarMenus);
                  }}
                >
                  {open ? (
                    <>
                      <span>
                        <ArrowLeftIcon style={{ fontSize: "1.6rem" }} />
                      </span>
                      <p>Main Menu</p>
                    </>
                  ) : (
                    <Tooltip title="Go back" placement="top">
                      <ArrowLeftIcon style={{ fontSize: "2.5rem" }} />
                    </Tooltip>
                  )}
                </button>
              ) : null}
            </>
            <List>
              {sidebarMenus.map(
                ({
                  route,
                  title,
                  id,
                  icon,
                  permission = "",
                }: sidebarMenusProps) => (
                  <>
                    {permission ? (
                      <HasAccess
                        permissions={[permission]}
                        renderAuthFailed={<div></div>}
                        isLoading={<div></div>}
                      >
                        <ComponentListItem
                          key={id}
                          route={route}
                          title={title}
                          id={id}
                          icon={icon}
                          open={open}

                        // click={handleMenuChange}
                        />
                      </HasAccess>
                    ) : (
                      <ComponentListItem
                        key={id}
                        route={route}
                        title={title}
                        id={id}
                        icon={icon}
                        open={open}

                      // click={handleMenuChange}
                      />
                    )}
                  </>
                )
              )}
            </List>
          </div>
        </div>

        {/* <DrawerHeader>
          <IconButton></IconButton>
        </DrawerHeader> */}

        <List className={styles.collapseDiv}>
          {theme.direction === "rtl" ? null : (
            <MuiListItem onClick={handleDrawerClose}>
              <div className={styles.drawerList}>
                <ListItemIcon>
                  <img src={CollapseIcon} alt="icons" className={styles.icon} />
                </ListItemIcon>
                <ListItemText>
                  {/* <img src={icon} alt="icons" /> */}
                  <div style={{ color: "white" }} className={styles.title}>
                    {open && "Collapse SideBar"}
                  </div>
                </ListItemText>
              </div>
            </MuiListItem>
          )}
        </List>
      </Drawer>
    </Box>
  );
}
